import * as React from 'react';
export const eftposSvg = React.forwardRef(function eftposSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.87 2.556C7.664 3.564 6.172 5.494 6.172 7.709c0 2.797 2.574 5.064 5.75 5.064 1.458 0 2.483-.337 3.681-1.059.128-.076.27-.133.365-.014.054.069.032.152-.01.227C14.65 14.33 11.986 16 8.997 16A7.999 7.999 0 0 1 1 8a7.986 7.986 0 0 1 2.991-6.24C5.361.66 8.796.507 9.87 2.556Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.866 5.654c0 2.657-2.537 4.811-5.667 4.811-.455 0-1.688-.062-2.57-.473-.252-.117-.226-.264-.053-.336.4-.165 3.546-.769 3.546-4.002 0-3.234-3.338-5.598-7.13-3.894A7.962 7.962 0 0 1 8.996 0c3.714 0 6.869 2.531 6.869 5.654Z',
    }),
  );
});
eftposSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var eftpos = {
  category: 'paymentmethod',
  colorable: true,
  name: 'eftpos',
  svg: eftposSvg,
};
